export default __webpack_public_path__ + "static/media/cinema_slide_1.10949e3d.jpg";